import * as React from 'react'
import { Outlet } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { ProcessesProcessCategoryEnum } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { useProcessContext } from 'modules/processes/pages/Process/ProcessRootPage'

import { ProcessTasksDataTable } from '../components/DataTable'
import { ProcessOverviewTasksProvider } from '../components/DataTable/components/ProcessOverviewTasksProvider'
import Header from '../components/Header'
import { ProcessAnalytics } from '../components/ProcessAnalytics'
import { useProcessOverviewTitle } from './useProcessOverviewTitle'

const ProcessOverviewPage = () => {
  const { process, template } = useProcessContext()

  useEffect(() => {
    track(trackingEvents.processes.processOverviewOpened, {
      category: process.category,
      processId: process.id,
    })
  }, [process?.id, process?.category])

  const { title, category } = useProcessOverviewTitle()

  return (
    <ProcessOverviewTasksProvider>
      <Header process={process} />
      <Box paddingY="s24" gap="s16">
        <ProcessAnalytics />
        <Text.Header2 weight="bold">{title}</Text.Header2>
        <ProcessTasksDataTable
          processId={process.id}
          category={category as ProcessesProcessCategoryEnum}
        />
      </Box>
      <Outlet context={{ process, template: template }} />
    </ProcessOverviewTasksProvider>
  )
}

export default ProcessOverviewPage
